<template>
  <div class="content">
    <navigation :navName="nav"></navigation>
    <template>
      <el-form ref="editForm"
               class="mobile-show-box form-wrapper"
               :label-width="formLabelWidth">
        <el-form-item v-for="(item,index) in configList"
                      :key="index">
          <div slot="label"
               class="slot-label">
            <span class="required"
                  v-if="item.config.require">*</span>
            <p>{{item.name}}</p>
          </div>
          <template v-if="item.config.name!=='updateTime'&&item.config.name!=='editors'&&item.config.name!=='sort'&&item.config.name!=='release'&&item.config.name!=='img'&&item.config.name!=='file'&&item.config.name!=='time'&&item.config.name!=='text'">
            <el-input placeholder="请输入内容"
                      v-model="item.config.content"
                      size="mini"
                      clearable>
            </el-input>
          </template>
          <template v-if="item.config.name==='img'">
            <el-upload :action="imgUpload"
                       :class="{disabled:uploadDisabledImage}"
                       list-type="picture-card"
                       :on-preview="handlePictureCardPreview"
                       :on-success="handlePictureSuccess"
                       :on-remove="handleRemoveImage"
                       :before-upload="beforeAvatarUpload"
                       :file-list="imgList"
                       :headers="isOverSea">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisibleImage">
              <img width="100%"
                   :src="dialogImageUrl"
                   alt="" />
            </el-dialog>
          </template>
          <template v-if="item.config.name==='file'">
            <el-upload :action="imgUpload"
                       :class="{disabled:uploadDisabledFile}"
                       :on-success="handleFileSuccess"
                       :on-remove="handleRemoveFile"
                       :before-upload="beforeUploadFile"
                       :file-list="fileList"
                       multiple
                       :limit="1"
                       :headers="isOverSea">
              <el-button size="small"
                         type="primary">点击上传</el-button>
            </el-upload>
          </template>
          <template v-if="item.config.name==='time'">
            <el-date-picker v-model="editTime"
                            type="date"
                            size="mini"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd">
            </el-date-picker>
          </template>
          <template v-if="item.config.name=='text'">
            <wang-editor @getEditor="getEditorContent">
            </wang-editor>
          </template>
        </el-form-item>
        <el-form-item label="优先级排序">
          <el-input type="number"
                    min="0"
                    size="mini"
                    v-model="sort"
                    class="num-input">
          </el-input>
          <span class="warning-span">注：数字越小优先级越高</span>
        </el-form-item>
        <el-form-item label="是否发布">
          <el-radio v-model="release"
                    label="true">发布</el-radio>
          <el-radio v-model="release"
                    label="false">不发布</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button size="mini"
                     type="primary"
                     @click="addArt()">提交</el-button>
          <el-button size="mini"
                     @click="back()">取消</el-button>
        </el-form-item>
      </el-form>
    </template>
  </div>
</template>
<style lang="less">
.disabled .el-upload--picture-card {
  display: none;
}
.slot-label {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>
<script>
import moment from 'moment';
import axios from 'axios';
import { mapState } from 'vuex';
import navigation from './navigation';
import wangEditor from '../wangEditor/wangEditor';
import api from '../../api/api';

export default {
  data() {
    return {
      dialogImageUrl: '',
      formLabelWidth: '120px',
      dialogVisibleImage: false,
      dialogVisibleFile: false,
      describe: '',
      imgUpload: `${api.url}upload`,
      uploadDisabledImage: false,
      uploadDisabledFile: false,
      img: '',
      imgList: [],
      fileList: [],
      nav: '',
      id: '',
      content: '',
      release: 'false',
      sort: 0,
      editTime: moment(new Date()).format('YYYY-MM-DD'),
    };
  },
  created() {
    this.id = this.$store.state.otherSettingId;
    if (this.id) {
      axios.get(`${api.url}otherSetDetail`, { params: { id: this.id } }).then((response) => {
        this.sort = response.data.content.sort;
        this.release = response.data.content.release;
        this.$store.commit('setOtherSettingDetail', response.data.content);
        const item = response.data.content;
        for (let i = 0; i < item.setConfig.length; i += 1) {
          if (item.setConfig[i].config.name === 'img') {
            if (item.setConfig[i].config.content) {
              this.uploadDisabledImage = true;
              this.img = item.setConfig[i].config.content;
              this.imgList = [{ url: this.$store.state.publicUrl + item.setConfig[i].config.content, status: 'finished' }];
            }
          }
          if (item.setConfig[i].config.name === 'file') {
            if (item.setConfig[i].config.content) {
              this.uploadDisabledFile = true;
              this.file = item.setConfig[i].config.content;
              this.fileList = [{ url: this.$store.state.publicUrl + item.setConfig[i].config.content, name: this.$store.state.publicUrl + item.setConfig[i].config.content, status: 'finished' }];
            }
          }
          if (item.setConfig[i].config.name === 'text') {
            this.$store.commit('getEditorContent', item.setConfig[i].config.content);
          }
          if (item.setConfig[i].config.name === 'time') {
            if (item.setConfig[i].config.content) {
              this.editTime = item.setConfig[i].config.content;
            }
          }
        }
      });
    } else {
      const data = this.$store.state.otherSettingDetail.setConfig;
      for (let i = 0; i < data.length; i += 1) {
        data[i].config.content = '';
      }
    }
  },
  computed: {
    ...mapState([
      'otherSettingDetail',
    ]),
    isOverSea() {
      const object = {};
      object.isOverSea = this.$store.state.is_overSea;
      return object;
    },
    configList() {
      return this.otherSettingDetail.setConfig.filter(item => item.config.name !== 'updateTime' && item.config.name !== 'editors' && item.config.name !== 'sort' && item.config.name !== 'release');
    },
  },
  components: {
    navigation,
    wangEditor,
  },
  mounted() {
    console.log(this.otherSettingDetail);
  },
  methods: {
    getEditorContent(editor) {
      this.editor = editor;
    },
    back() {
      this.$router.back(-1);
    },
    // 修改设置
    addArt() {
      const myConfig = this.$store.state.otherSettingDetail.setConfig;
      for (let i = 0; i < myConfig.length; i += 1) {
        if (myConfig[i].config.name === 'sort' && myConfig[i].config.content === '') {
          myConfig[i].config.content = 0;
        }
        if (myConfig[i].config.name === 'img') {
          myConfig[i].config.content = this.img;
        }
        if (myConfig[i].config.name === 'file') {
          myConfig[i].config.content = this.file;
        }
        if (myConfig[i].config.name === 'text') {
          if (myConfig[i].config.require && this.editor.txt.text() === '' && this.editor.txt.html().indexOf('img') < 0 && this.editor.txt.html().indexOf('iframe') < 0) {
            this.$message({
              message: `请填写${myConfig[i].name}`,
              type: 'warning',
            });
            return;
          }
          myConfig[i].config.content = this.editor.txt.html();
        }
        if (myConfig[i].config.name === 'time') {
          myConfig[i].config.content = this.editTime;
        }
        if (myConfig[i].config.require && myConfig[i].config.content === '') {
          this.$message({
            message: `请填写${myConfig[i].name}`,
            type: 'warning',
          });
          return;
        }
      }
      const data = {
        wid: this.$store.state.websiteId,
        type: this.otherSettingDetail.config,
        configs: this.otherSettingDetail.setConfig,
        id: this.id,
        release: this.release,
        sort: this.sort,
        name: this.$store.state.navName,
      };
      axios.post(`${api.url}editOtherSettings`, data).then((response) => {
        if (response.data.ret === 0) {
          this.$alert(response.data.msg, '', {
            confirmButtonText: '确定',
            callback: () => {
              window.history.back();
            },
          });
        }
      });
    },
    handleRemoveImage() {
      this.uploadDisabledImage = false;
      this.img = '';
    },
    handleRemoveFile() {
      this.file = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleImage = true;
    },
    handlePictureSuccess(file) {
      if (file.ret === 0) {
        this.uploadDisabledImage = true;
        this.img = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    handleFileSuccess(file) {
      if (file.ret === 0) {
        this.file = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isGif = file.type === 'image/gif';
      if (!isJPG && !isPng && !isGif) {
        this.$message.error('上传图片只能是 JPG 格式,GIF格式 或者 PNG 格式!');
      }
    },
    beforeUploadFile(file) {
      const extension = file.name.split('.')[1] === 'xls';
      const extension2 = file.name.split('.')[1] === 'xlsx';
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        this.$message.error('上传文件只支持xls、xlsx格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不超过 10MB!');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/websiteConfig/editOtherSetting.vue